import * as React from "react";
const SvgWardrobeRack = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.036 2.282a.75.75 0 1 0-1.5 0v.25H6.032a1.75 1.75 0 0 0-1.75 1.75v13c0 .049.005.096.014.142l-1.87 3.974a.75.75 0 0 0 1.357.639l1.27-2.697 1.225 2.688a.75.75 0 1 0 1.365-.622l-1.685-3.694h12.138l-1.735 3.686a.75.75 0 0 0 1.357.639l1.27-2.697 1.225 2.688a.75.75 0 1 0 1.365-.622l-1.811-3.972c.01-.049.015-.1.015-.152v-13a1.75 1.75 0 0 0-1.75-1.75h-3.996v-.25Zm4.246 13.93V4.282a.25.25 0 0 0-.25-.25h-3.996v.365l3.186 2.275a.75.75 0 0 1-.436 1.36h-7a.75.75 0 0 1-.436-1.36l3.186-2.275v-.365H6.032a.25.25 0 0 0-.25.25v11.93h12.5Zm-3.837-9.68-1.16-.828-1.159.828h2.32Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgWardrobeRack;
